<template>
  <div class="ai-logic-dropdown-wrapper" v-click-outside="onClose">
    <div
      v-for="item in actions"
      :key="item.name"
      class="action-button"
      @mousedown.stop
      @click="onSelectAction($event, item)"
    >
      <b-spinner
        v-if="item.isLoading"
        class="spinner"
        label="Spinning"
      ></b-spinner>
      <b-icon v-if="!item.isLoading" :icon="item.icon" font-scale="2"></b-icon>
    </div>

    <!-- <div v-if="isReasoningInputVisible" class="reasoning-input">
      <input
        v-model="reasoningPrompt"
        @keyup.enter="onUpdateReasoning"
        placeholder="Ask AI"
        type="text"
      />

      <b-icon
        @click.stop="toggleReasoningInput(false)"
        class="input-icon"
        icon="x-circle"
        font-scale="2"
      >
      </b-icon>
      <b-icon
        @click.stop="onUpdateReasoning"
        class="input-icon"
        icon="check-circle-fill"
        font-scale="2"
      >
      </b-icon>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      isReasoningInputVisible: true,
      reasoningPrompt: '',
    };
  },
  props: {
    actions: {
      type: Array,
      default: [],
    },
  },
  methods: {
    onClose(event) {
      if (this.isActionLoading || !this.isVisible) return;
      this.$emit('close', event);
    },
    toggleReasoningInput(isVisible = false) {
      this.isReasoningInputVisible = isVisible;
      if (!isVisible) {
        this.reasoningPrompt = '';
      }
    },
    onUpdateReasoning() {
      this.actions.forEach((item) => {
        if (item.name == 'updateReasoning') {
          item.isLoading = true;
          this.$emit('onUpdateReasoning', item);
        }
      });
      this.toggleReasoningInput(false);
    },
    onSelectAction(event, item) {
      event.stopPropagation();
      if (this.isActionLoading) return;
      if (item.name == 'updateReasoning') {
        this.$emit(item.action, item);
        return;
      } else {
        this.toggleReasoningInput(false);
      }

      this.$emit(item.action, item);
    },
  },

  mounted() {
    this.isVisible = true;
  },
  beforeDestroy() {
    this.toggleReasoningInput(false);
  },

  computed: {
    isActionLoading() {
      return this.actions.some((action) => action.isLoading);
    },
  },
};
</script>

<style scoped>
.ai-logic-dropdown-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  color: black;
  gap: 16px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  padding: 8px 12px;
  border-radius: 6px;
  background-color: #ffffff;
  position: relative;
}

.ai-logic-dropdown-wrapper .action-button {
  cursor: pointer;
}
.spinner,
.action-button {
  width: 25px;
  height: 25px;
}

.reasoning-input {
  position: absolute;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  top: 30px;
  left: 100px;
  border-radius: 6px;
  padding: 2px 8px;
  z-index: 20;
  background-color: white;
  display: flex;
  gap: 2px;
  align-items: center;
}
.reasoning-input input {
  color: black;
  outline: none;
}
.input-icon {
  cursor: pointer;
}
</style>
